import { render, staticRenderFns } from "./glassesSettings.vue?vue&type=template&id=4fc9f143&scoped=true&"
import script from "./glassesSettings.vue?vue&type=script&lang=js&"
export * from "./glassesSettings.vue?vue&type=script&lang=js&"
import style0 from "./glassesSettings.vue?vue&type=style&index=0&id=4fc9f143&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9f143",
  null
  
)

export default component.exports